export const authStorageKeys = {
    ACCESS_TOKEN: 'auth0.storage.access_token',
    ID_TOKEN: 'auth0.storage.id_token',
    SUBJECT: 'auth0.storage.subject',
    USER_ID: 'auth0.storage.user_id',
    COMPANY_ID: 'auth0.storage.company_id',
    LOGGED_USER_EMAIL: 'auth0.storage.logged_user_email',
    PERSONAS: 'auth0.storage.personas',
    APPLICATIONS: 'auth0.storage.applications',
};
//# sourceMappingURL=authStorageKeys.js.map